import { IconPropType } from '@/ui/Icon';

export const DROPDOWN_ICON_CLOSED: IconPropType = 'caret-down';
export const DROPDOWN_ICON_OPEN: IconPropType = 'caret-up';
export const CHECKMARK_ICON: IconPropType = 'check';
export const CLOSE_ICON: IconPropType = 'xmark';
